export const Reward = ({ secondaryColor = 'none' }: { secondaryColor?: string }) => (
  <svg width="24" height="24" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M10.0002 13C10.0167 13 10.0332 12.9999 10.0497 12.9998C12.2322 12.9822 14.137 11.7993 15.1726 10.0428C15.6985 9.15066 16.0002 8.11057 16.0002 7C16.0002 3.68629 13.314 1 10.0002 1C6.68654 1 4.00024 3.68629 4.00024 7C4.00024 8.11082 4.30211 9.15114 4.82829 10.0434C5.87175 11.8128 7.79736 13 10.0002 13Z"
      fill={secondaryColor}
    />
    <path d="M10.0022 13.0031L13.4022 18.8931L15.0002 15.6601L18.5982 15.8921L15.1982 10.0031" fill={secondaryColor} />
    <path d="M4.80234 10.0031L1.40234 15.8931L5.00034 15.6601L6.59834 18.8921L9.99834 13.0031" fill={secondaryColor} />
    <path
      d="M9.99834 13.0031L6.59834 18.8921L5.00034 15.6601L1.40234 15.8931L4.80234 10.0031L4.82829 10.0434M9.99834 13.0031L10.0497 12.9998M9.99834 13.0031H10.0022L13.4022 18.8931L15.0002 15.6601L18.5982 15.8921L15.1982 10.0031L15.1726 10.0428M10.0497 12.9998C10.0332 12.9999 10.0167 13 10.0002 13C7.79736 13 5.87175 11.8128 4.82829 10.0434M10.0497 12.9998C12.2322 12.9822 14.137 11.7993 15.1726 10.0428M4.82829 10.0434C4.30211 9.15114 4.00024 8.11082 4.00024 7C4.00024 3.68629 6.68654 1 10.0002 1C13.314 1 16.0002 3.68629 16.0002 7C16.0002 8.11057 15.6985 9.15066 15.1726 10.0428"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="square"
      strokeLinejoin="round"
    />
  </svg>
)
